import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DupTransactionsDialogComponent } from './dup-transactions-dialog.component';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { FormattedDateModule } from 'src/app/shared/pipes/formatted-date/formatted-date.module';
import { RxNumberModule } from 'src/app/shared/pipes/rx-number/rx-number.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';



@NgModule({
  declarations: [DupTransactionsDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    FormattedDateModule,
    RxNumberModule,
    ButtonModule
  ],
  exports: [DupTransactionsDialogComponent]
})
export class DupTransactionsDialogModule { }
